import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notice d-flex align-items-center bg-light-warning rounded border-warning border border-dashed p-4 mb-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "fas fa-lock fs-3 text-warning me-4" }, null, -1)
const _hoisted_3 = { class: "fs-6 fw-bold text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('message.WMS_VIEW_ONLY')), 1)
  ]))
}